module.exports = __webpack_public_path__ + "media/react/assets/imgs/landing-9d1a6199423979b5a1603e15ffffb36f.png";